"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rulesSpiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function rulesSpiClient(networkClient) {
    return {
        listRules: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.RULES_WEB_SERVICE, `/spi/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules`, query, config);
        },
        sendRules: (message) => {
            return networkClient.fireToTopic(data_lib_1.RULES_TOPIC, message, "Unable to send rules message, error=");
        },
    };
}
exports.rulesSpiClient = rulesSpiClient;
